import { j as t } from "../../jsx-runtime-B6kdoens.js";
import { useState as v, useCallback as g, useMemo as R } from "react";
import { c as b, a as M } from "../../index-CROKJrb5.js";
import { c as N, f as S } from "../../create-component-CBAeEoQ6.js";
import { u as y } from "../../use-unique-id-BA9hSqap.js";
const H = b({
  base: "cur-absolute cur-inset-1/2 -cur-z-30 cur-block cur-opacity-0 -cur-translate-x-1/2 -cur-translate-y-1/2 cur-rounded-full cur-bg-surface-highlight cur-transition-all",
  variants: {
    size: {
      sm: "cur-h-[1.25rem] cur-w-[1.25rem]",
      md: "cur-h-[1.875rem] cur-w-[1.875rem]"
    },
    readOnly: {
      false: "group-hover:cur-opacity-100"
    }
  }
}), j = [1, 2, 3, 4, 5], $ = j.length, I = ({
  id: r,
  name: a,
  readOnly: c = !1,
  selectedValue: o,
  size: n,
  value: u,
  ...s
}) => {
  const i = n === "sm" ? 16 : 24, l = `${r}-${u}`, m = a || `${r}-option`;
  return /* @__PURE__ */ t.jsxs(
    "label",
    {
      className: "cur-group cur-relative [&_svg_path]:focus-within:cur-block",
      htmlFor: l,
      children: [
        /* @__PURE__ */ t.jsxs("div", { className: "cur-absolute -cur-z-10 cur-h-0 cur-w-0 cur-overflow-hidden cur-opacity-0", children: [
          u,
          " star",
          u > 1 ? "s" : ""
        ] }),
        c ? null : /* @__PURE__ */ t.jsx(
          "input",
          {
            ...s,
            name: m,
            type: "radio",
            value: u,
            id: l,
            className: "cur-absolute cur-left-0 cur-z-10 cur-h-full cur-w-full cur-cursor-pointer cur-opacity-0"
          }
        ),
        /* @__PURE__ */ t.jsxs(
          "svg",
          {
            width: i,
            height: i,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ t.jsx(
                "path",
                {
                  d: "M8.8694 1.65973C8.74702 1.26634 8.39603 1 8 1C7.60397 1 7.25298 1.26634 7.1306 1.65973L5.89918 5.61814H1.9142C1.51817 5.61814 1.16718 5.88448 1.0448 6.27787C0.922424 6.67126 1.05649 7.10222 1.37688 7.34535L4.6008 9.79178L3.36937 13.7502C3.24699 14.1436 3.38106 14.5745 3.70145 14.8177C4.02185 15.0608 4.45569 15.0608 4.77609 14.8177L8 12.3712L11.2239 14.8177C11.5443 15.0608 11.9782 15.0608 12.2985 14.8177C12.6189 14.5745 12.753 14.1436 12.6306 13.7502L11.3992 9.79178L14.6231 7.34535C14.9435 7.10222 15.0776 6.67126 14.9552 6.27787C14.8328 5.88448 14.4818 5.61814 14.0858 5.61814H10.1008L8.8694 1.65973Z",
                  stroke: "currentColor"
                }
              ),
              /* @__PURE__ */ t.jsx("mask", { id: `${l}-fill-mask`, children: /* @__PURE__ */ t.jsx(
                "rect",
                {
                  x: "0",
                  y: "0",
                  width: `${o * 14 + 1}`,
                  height: "100%",
                  fill: "white"
                }
              ) }),
              /* @__PURE__ */ t.jsx(
                "path",
                {
                  d: "M5.59909 5.77787C5.81802 5.77787 6.01148 5.63545 6.07652 5.4264L7.48386 0.902507C7.5623 0.650362 7.77827 0.5 8.00003 0.5C8.22179 0.5 8.43776 0.650363 8.5162 0.902506L9.92354 5.4264C9.98857 5.63545 10.182 5.77787 10.401 5.77787H14.9552C15.177 5.77787 15.393 5.92824 15.4714 6.18038C15.5508 6.43558 15.4601 6.70702 15.2671 6.85352L11.5826 9.64944C11.4149 9.77668 11.3449 9.99529 11.4074 10.1963L12.8147 14.7202C12.8941 14.9754 12.8035 15.2468 12.6104 15.3933C12.4229 15.5356 12.1742 15.5356 11.9867 15.3933L8.30228 12.5974C8.12359 12.4618 7.87647 12.4618 7.69778 12.5974L4.01331 15.3933C3.82583 15.5356 3.57713 15.5356 3.38965 15.3933C3.19659 15.2468 3.10592 14.9754 3.18531 14.7202L4.59265 10.1963C4.65518 9.99529 4.58514 9.77668 4.41747 9.64944L0.733002 6.85352C0.539942 6.70702 0.449272 6.43558 0.528663 6.18038C0.607103 5.92824 0.82307 5.77787 1.04483 5.77787H5.59909Z",
                  fill: "currentColor",
                  mask: `url(#${l}-fill-mask)`
                }
              ),
              /* @__PURE__ */ t.jsx(
                "path",
                {
                  className: "cur-hidden cur-text-focus",
                  d: "M5.89919 6.05564C6.09076 6.05564 6.26004 5.93102 6.31694 5.7481L7.54837 1.78969C7.617 1.56907 7.80598 1.4375 8.00002 1.4375C8.19406 1.4375 8.38303 1.56907 8.45166 1.78969L9.68309 5.7481C9.73999 5.93102 9.90928 6.05564 10.1008 6.05564H14.0858C14.2799 6.05564 14.4688 6.18721 14.5375 6.40783C14.6069 6.63114 14.5276 6.86864 14.3587 6.99683L11.1348 9.44326C10.988 9.55459 10.9268 9.74588 10.9815 9.92174L12.2129 13.8801C12.2824 14.1034 12.203 14.341 12.0341 14.4691C11.8701 14.5936 11.6524 14.5936 11.4884 14.4691L8.26448 12.0227C8.10813 11.9041 7.8919 11.9041 7.73555 12.0227L4.51164 14.4691C4.3476 14.5936 4.12998 14.5936 3.96594 14.4691C3.79701 14.341 3.71767 14.1034 3.78714 13.8801L5.01856 9.92174C5.07327 9.74588 5.01199 9.55459 4.86528 9.44326L1.64137 6.99683C1.47244 6.86864 1.39311 6.63114 1.46257 6.40783C1.53121 6.18721 1.72018 6.05564 1.91422 6.05564H5.89919Z",
                  stroke: "currentColor"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ t.jsx("div", { className: H({ readOnly: c, size: n }), "aria-hidden": !0 })
      ]
    }
  );
}, T = (r, a) => {
  const c = Math.floor(a), o = a - c;
  return r <= c ? 1 : r === c + 1 ? o : 0;
}, C = (r, a = 1) => r === void 0 ? void 0 : Math.min(
  $,
  Math.max(a, typeof r == "string" ? parseFloat(r) : r)
), q = N(
  "Rating",
  S(
    ({
      className: r,
      defaultValue: a,
      disabled: c,
      name: o,
      id: n,
      readOnly: u = !1,
      onChange: s,
      size: i = "md",
      value: l,
      ...m
    }, k) => {
      const d = y("rating", n), [h, x] = v(
        C(a, u || c ? 0 : 1)
      ), L = g(
        (e) => {
          const p = C(e.currentTarget.value);
          x(p), s == null || s(e, p);
        },
        [s]
      ), w = g(
        (e) => {
          C(e.currentTarget.value) === h && (x(0), s == null || s(e, 0));
        },
        [s, h]
      ), f = C(l, u || c ? 0 : 1) || h || 0, V = R(
        () => j.map((e) => /* @__PURE__ */ t.jsx(
          I,
          {
            id: d,
            readOnly: u || c,
            name: o,
            onChange: L,
            onClick: w,
            checked: e === f,
            selectedValue: T(e, f),
            size: i,
            value: e
          },
          e
        )),
        [
          f,
          c,
          L,
          w,
          d,
          u,
          o,
          i
        ]
      );
      return /* @__PURE__ */ t.jsx(
        "div",
        {
          className: M("cur-relative cur-flex cur-text-brand", r),
          ...m,
          id: d,
          ref: k,
          children: V
        }
      );
    }
  )
);
export {
  q as Rating,
  $ as StarCount
};
//# sourceMappingURL=index.js.map
